import { gql } from '@apollo/client/core';

export const CONTRACT_DEPOSIT_INFORMATION = gql`
  query contractDepositInformation($input: ID!) {
    contractDepositInformation(contract_attendee_id: $input) {
      contract_attendee_id
    }
  }
`;
